export enum ETableIds {
  DOWNLOAD_CENTER = 'download-center-table',
  NOTIFICATIONS = 'notifications-table',
  PORTFOLIO_MANAGEMENT_PERFORMANCE_POSITIONS = 'portfolio-management-performance-positions',
  TRADE_ORDERS = 'trade-orders-table',
  TRADE_ORDERS_SECURITY_BROWSER = 'trade-orders-security-browser-table',
  USER_MANAGEMENT = 'user-management-table',
  MFFS_PERFORMANCE_TABLE = 'mffs-performance-table',
  MFFS_PERFORMANCE_ANALYSIS_TABLE = 'mffs-performance-analysis-table',

  // Playground
  PLAYGROUND_SAMPLE = 'sample-table',
  PLAYGROUND_SAMPLE_2 = 'sample-table-2',
  PLAYGROUND_SCAFFOLD = 'scaffold-table',
  PLAYGROUND_SHARED = 'shared-table',
  PLAYGROUND_MUTABLE = 'mutable-table',
  PLAYGROUND_BROWSABLE = 'browsable-table-playground'
}
